import ButtonSmallMixin from './mixins/button-small-mixin.js';
import ButtonOutlinedLightMixin from './mixins/button-outlined-light-mixin.js';
import TpButton from './tp-button.js';

class TpButtonOutlinedLightSmall extends
  ButtonSmallMixin(
  ButtonOutlinedLightMixin(
    TpButton
  )) {}

export default TpButtonOutlinedLightSmall;


